export default class {
    _id;
    _uid;
    _client;
    _area;
    _region;
    _pagesCount;
    _address;
    _receiver;
    _createdOn;
    _isApproved;
    _approvedOn;

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get uid() {
        return this._uid;
    }

    set uid(value) {
        this._uid = value;
    }

    get client() {
        return this._client;
    }

    set client(value) {
        this._client = value;
    }

    get area() {
        return this._area;
    }

    set area(value) {
        this._area = value;
    }

    get region() {
        return this._region;
    }

    set region(value) {
        this._region = value;
    }

    get pagesCount() {
        return this._pagesCount;
    }

    set pagesCount(value) {
        this._pagesCount = value;
    }

    get address() {
        return this._address;
    }

    set address(value) {
        this._address = value;
    }

    get receiver() {
        return this._receiver;
    }

    set receiver(value) {
        this._receiver = value;
    }

    get createdOn() {
        return this._createdOn;
    }

    set createdOn(value) {
        this._createdOn = value;
    }

    get isApproved() {
        return this._isApproved;
    }

    set isApproved(value) {
        this._isApproved = value;
    }

    get approvedOn() {
        return this._approvedOn;
    }

    set approvedOn(value) {
        this._approvedOn = value;
    }
}